import React, { PureComponent } from 'react';
import { func, bool } from 'prop-types';
import { reduxForm } from 'redux-form';
import Radium from 'radium';
import { UTButton } from '@widergy/energy-ui';

import AuthFormBox from 'app/components/AuthFormBox';
import { message } from 'utils/stringUtils';
import { SIGNUP_ADD_ACCOUNT } from 'constants/reduxForms';
import { ROUTES } from 'constants/routes';
import { gaTrackPageView } from 'services/AnalyticsService';

import ReturnToSignIn from '../ReturnToSignIn';

import AddAccount from './layout';
import styles from './styles';

class AddAccountContainer extends PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.SIGN_UP);
  }

  render() {
    const { handleSubmit, submitFailed, invalid } = this.props;

    return (
      <form onSubmit={handleSubmit} style={styles.container}>
        <AuthFormBox title={message('Signup:addAccount')}>
          <AddAccount />
        </AuthFormBox>
        <UTButton disabled={submitFailed && invalid} style={styles.submit} type="submit">
          {message('Signup:submit')}
        </UTButton>
        <ReturnToSignIn />
      </form>
    );
  }
}

AddAccountContainer.propTypes = {
  handleSubmit: func.isRequired,
  submitFailed: bool,
  invalid: bool
};

export default reduxForm({ form: SIGNUP_ADD_ACCOUNT })(Radium(AddAccountContainer));
